/**
 * Fase 2 (W36): textos dos filtros das listas (`componentes/filtros-lista.tsx`), usados no Contas, no Financeiro e no
 * Compras. No núcleo porque as três telas mostram os mesmos controles.
 */
export const filtrosListaPt = {
  filtrosLista: {
    periodoPor: 'Período por',
    todoPeriodo: 'Todo o período',
    bases: { vencimento: 'Vencimento', competencia: 'Mês de referência', caixa: 'Data do pagamento (caixa)' },
    valorMin: 'Valor mínimo',
    valorMax: 'Valor máximo',
    faixaValor: 'Faixa de valor',
    faixaInvalida: 'O valor mínimo deve ser menor ou igual ao máximo.',
    buscar: { cliente: 'Filtrar por cliente', fornecedor: 'Filtrar por fornecedor', todos: 'Filtrar por cliente ou fornecedor' },
    escolhidos: { cliente: 'Clientes no filtro', fornecedor: 'Fornecedores no filtro', todos: 'Clientes e fornecedores no filtro' },
    campo: { cliente: 'Cliente', fornecedor: 'Fornecedor', todos: 'Cliente ou fornecedor' },
    remover: 'Tirar {{nome}} do filtro',
    semAcesso: 'Cadastro sem acesso',
    semAcessoCampo: '{{campo}}: Cadastro sem acesso',
    limite: 'Até {{max}} no filtro. Tire um para escolher outro.',
    adicionar: 'Adicionar {{campo}}',
    noFiltro: '{{campo}}: escolhidos no filtro',
    maisFiltros: 'Mais filtros',
    maisFiltrosN: 'Mais filtros ({{n}})',
    chipValor: '{{campo}}: {{valor}}',
  },
};

export const filtrosListaEn: typeof filtrosListaPt = {
  filtrosLista: {
    periodoPor: 'Period by',
    todoPeriodo: 'Any date',
    bases: { vencimento: 'Due date', competencia: 'Reference month', caixa: 'Payment date (cash)' },
    valorMin: 'Minimum amount',
    valorMax: 'Maximum amount',
    faixaValor: 'Amount range',
    faixaInvalida: 'The minimum amount must be less than or equal to the maximum.',
    buscar: { cliente: 'Filter by customer', fornecedor: 'Filter by supplier', todos: 'Filter by customer or supplier' },
    escolhidos: { cliente: 'Customers in the filter', fornecedor: 'Suppliers in the filter', todos: 'Customers and suppliers in the filter' },
    campo: { cliente: 'Customer', fornecedor: 'Supplier', todos: 'Customer or supplier' },
    remover: 'Remove {{nome}} from the filter',
    semAcesso: 'Record you cannot access',
    semAcessoCampo: '{{campo}}: Record you cannot access',
    limite: 'Up to {{max}} in the filter. Remove one to pick another.',
    adicionar: 'Add {{campo}}',
    noFiltro: '{{campo}}: chosen in the filter',
    maisFiltros: 'More filters',
    maisFiltrosN: 'More filters ({{n}})',
    chipValor: '{{campo}}: {{valor}}',
  },
};

export const filtrosListaEs: typeof filtrosListaPt = {
  filtrosLista: {
    periodoPor: 'Período por',
    todoPeriodo: 'Todo el período',
    bases: { vencimento: 'Vencimiento', competencia: 'Mes de referencia', caixa: 'Fecha del pago (caja)' },
    valorMin: 'Valor mínimo',
    valorMax: 'Valor máximo',
    faixaValor: 'Rango de valor',
    faixaInvalida: 'El valor mínimo debe ser menor o igual al máximo.',
    buscar: { cliente: 'Filtrar por cliente', fornecedor: 'Filtrar por proveedor', todos: 'Filtrar por cliente o proveedor' },
    escolhidos: { cliente: 'Clientes en el filtro', fornecedor: 'Proveedores en el filtro', todos: 'Clientes y proveedores en el filtro' },
    campo: { cliente: 'Cliente', fornecedor: 'Proveedor', todos: 'Cliente o proveedor' },
    remover: 'Quitar {{nome}} del filtro',
    semAcesso: 'Registro sin acceso',
    semAcessoCampo: '{{campo}}: Registro sin acceso',
    limite: 'Hasta {{max}} en el filtro. Quita uno para elegir otro.',
    adicionar: 'Agregar {{campo}}',
    noFiltro: '{{campo}}: elegidos en el filtro',
    maisFiltros: 'Más filtros',
    maisFiltrosN: 'Más filtros ({{n}})',
    chipValor: '{{campo}}: {{valor}}',
  },
};
